import { render, staticRenderFns } from "./SosVersion.vue?vue&type=template&id=9400a178&scoped=true&lang=pug"
import script from "./SosVersion.vue?vue&type=script&lang=js"
export * from "./SosVersion.vue?vue&type=script&lang=js"
import style0 from "./SosVersion.vue?vue&type=style&index=0&id=9400a178&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9400a178",
  null
  
)

export default component.exports